import { gsap } from '../utils/gsap';
import { ScrollTrigger } from '../utils/gsap';

export function initParallax() {
  if (window.innerWidth <= 1200) return;

  const parallaxItems = [
    { selector: '.parallax-5', yPercent: 5 },
    { selector: '.parallax-10', yPercent: 10 },
    { selector: '.parallax-15', yPercent: 15 },
    { selector: '.parallax-20', yPercent: 20 },
    { selector: '.parallax-n-10', yPercent: -10 },
    { selector: '.parallax-n-15', yPercent: -15 },
  ];

  parallaxItems.forEach(({ selector, yPercent }) => {
    gsap.utils.toArray(selector).forEach((elem) => {
      gsap.to(elem, {
        scrollTrigger: {
          trigger: elem,
          scrub: 3,
        },
        yPercent,
      });
    });
  });

  gsap.utils.toArray('.zoom').forEach((elem) => {
    gsap.to(elem, {
      scrollTrigger: {
        trigger: elem,
        start: 'top 95%',
        end: '+=150%',
        scrub: 5,
      },
      ease: 'none',
      scale: 1.2,
    });
  });
}